/** Validates a column string (A–ZZ). */
export function isValidColumn(col: string): boolean {
  return /^[A-Za-z]{1,2}$/.test(col);
}

/** Converts a column letter (A, B, ..., Z, AA, ...) to a 1-based number. */
export function columnToNumber(col: string): number {
  let n = 0;
  for (const ch of col.toUpperCase()) {
    n = n * 26 + (ch.charCodeAt(0) - 64);
  }
  return n;
}

/** Returns the [min, max] column letters from an array of column strings. */
export function minMaxColumns(columns: string[]): [string, string] {
  const valid = columns.filter(isValidColumn);
  
  if (valid.length === 0) {
    return ["A", "A"];
  }

  const sorted = [...valid].sort((a, b) => columnToNumber(a) - columnToNumber(b));
  return [sorted[0], sorted[sorted.length - 1]];
}
